import { render, staticRenderFns } from "./finalizeSoRegisterationMobile.vue?vue&type=template&id=1b3de007"
import script from "./finalizeSoRegisterationMobile.vue?vue&type=script&lang=js"
export * from "./finalizeSoRegisterationMobile.vue?vue&type=script&lang=js"
import style0 from "./finalizeSoRegisterationMobile.vue?vue&type=style&index=0&id=1b3de007&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports